import { motion } from "framer-motion";

export function SectionHeader({
  overline,
  title,
  subtitle,
  align = "left",
  inverse = false,
  testIdPrefix,
}) {
  return (
    <div
      className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl`}
      data-testid={testIdPrefix ? `${testIdPrefix}-header` : undefined}
    >
      {overline && (
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className={`overline ${inverse ? "text-gold" : "text-emerald-brand"}`}
        >
          {overline}
        </motion.div>
      )}
      <motion.h2
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6, delay: 0.05 }}
        className={`font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight mt-4 ${
          inverse ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </motion.h2>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className={`mt-6 text-base sm:text-lg leading-relaxed ${
            inverse ? "text-white/70" : "text-slate-brand"
          }`}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
}

export default SectionHeader;
